import styled from 'styled-components'

export const Input = styled.input`
  margin-right: 6px;
`

export const Select = styled.select`
  margin-right: 6px;
`
